import React, { useEffect, useState } from 'react'
import { Box, Grid, Icon, IconButton, Stack, Typography } from '@mui/material'
import { AddCircle, Check, CheckCircle } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { Workout } from '../../../models/interfaces/workout.interface'
import { useAppSelector } from '../../../redux/hooks'
import { selectVideo } from '../../../redux/reducers/modal-player/modal-player.selectors'
import { Thumbnail } from '../../Thumbnail'

type Props = {
  item: Workout
  recorded?: string[]
  addWorkout?: () => void
  workoutSelected?: boolean
}

export const VideoItemList = ({ item, addWorkout, recorded = [], workoutSelected }: Props) => {
  const theme = useTheme()
  const video = useAppSelector(selectVideo)
  const [selectedVideoId, setSelectedVideoId] = useState<string>('')
  const { t } = useTranslation()

  useEffect(() => {
    if (video?.id) {
      setSelectedVideoId(video.id)
    }
  }, [video])

  const changeColor = () => {
    if (selectedVideoId === item.id) {
      return theme.palette.grey[900]
    }
    return theme.palette.grey[800]
  }

  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="center" mb={1}
      style={{ backgroundColor: changeColor() }} p={1}>
      <Grid item xs={3} sx={{ marginLeft: 2 }}>
        <Thumbnail data={item} />
      </Grid>
      <Grid item xs={6} padding={2}>
        <Typography sx={{ textAlign: 'justify', color: theme.palette.text.secondary }}>
          {t(`workouts.${item.name}`, { defaultValue: item.name })}
        </Typography>
        {recorded.includes(item.id) && <Check color="success" />}
      </Grid>
      <Grid item xs={1.5} marginLeft={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton color="primary" onClick={addWorkout} >
              <AddCircle sx={{ fontSize: 28 }} />
            </IconButton>
          </Box>
          { workoutSelected && <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} padding={1} >
            <CheckCircle sx={{ fontSize: 28, color: theme.palette.success.dark }} />
          </Box>
          }
        </Stack>
      </Grid>
    </Grid>
  )
}
